import React from 'react';
import { useSelector } from 'react-redux';

import { ExperimentId } from '../../../../../../../common/experiments/experimentsConstants';
import { getIsFeatureEnabledForCurrentUser } from '../../../../../../element/feature/elementFeatureSelector';
import IconTool from '../IconTool';
import IconToolV2 from './IconToolV2';

const assetPickersV2EnabledSelector = getIsFeatureEnabledForCurrentUser(ExperimentId.assetPickersV2);

/**
 * Selects the board icon tool. Legacy `IconTool` stays until the Roma asset pickers roll out.
 */
const IconToolSwitch: React.FC<React.ComponentProps<typeof IconToolV2>> = (props) => {
    const isAssetPickersV2Enabled = useSelector(assetPickersV2EnabledSelector);

    if (!isAssetPickersV2Enabled) return <IconTool {...props} />;

    return <IconToolV2 {...props} />;
};

export default IconToolSwitch;
